module.exports = __webpack_public_path__ + "static/img/m_role.ad6dca3.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/mz/m_role.png
// module id = JjEL
// module chunks = 7